import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClientProvider, QueryClient } from '@tanstack/react-query'
import { initMonitor } from './services/monitoringService'
import Router from './router'
import config from './config'
import { isStartPath, prefetchStart } from './startPrefetch'
import { retiredTarget } from './retiredPaths'
import './polyfills'
import './index.css'
// Only web-core's @font-face rules, none of its code: the chat widget's theme draws in its faces
// on every page, /start included.
import '@wallyhealth/web-core/dist/fonts/index.css'

// A retired page sends its old link on to the member web, before anything here can record it.
// public/index.html has already taken the query off the address bar and kept it aside.
const retired = retiredTarget(
  window.location.pathname,
  window.__retiredSearch ?? window.location.search,
  config.PORTAL_URL
)
if (retired) {
  window.history.replaceState(null, '', window.location.pathname)
  window.location.replace(retired)

  // Only while the browser leaves: a way on if it doesn't.
  const onward = document.createElement('a')
  onward.href = retired
  onward.textContent = 'Continue to Wally'
  document.getElementById('root').appendChild(onward)
} else {
  initMonitor()
}

const queryClient = new QueryClient()

// /start's first requests go out now, while the flow's code is still on its way.
if (isStartPath(window.location.pathname)) prefetchStart(queryClient)

const root = ReactDOM.createRoot(document.getElementById('root'))

if (!retired) {
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <Router />
      </QueryClientProvider>
    </React.StrictMode>
  )
}
